import { getUnpaginatedAll } from '../../../helpers/getUnpaginatedAll'
import { ecbrRequest } from '../../request/ecbrRequest'

export const pillars = {
  getAll: async () => ecbrRequest.get('/pillars'),
  getById: async (id) => ecbrRequest.get(`/pillars/${id}`),
  create: async (data) => ecbrRequest.post('/pillars', data),
  update: async (id, data) => ecbrRequest.patch(`/pillars/${id}`, data),
  delete: async (id) => ecbrRequest.delete(`/pillars/${id}`),
  getUserCertificatePillars: async (certificateId, params = {}) =>
    ecbrRequest.get(`/company/pillars`, {
      params: { ...params, ...(certificateId && { certificateId }) }
    }),
  getAllCertificatePillars: async (certificateId, params = {}) => {
    return {
      data: await getUnpaginatedAll(
        (pagination) =>
          ecbrRequest.get(`/company/pillars`, {
            params: { ...params, ...pagination, certificateId }
          }),
        params.page,
        params.take
      )
    }
  },
  associateUserToCertificatePillar: async (userId, certificatePillarId) =>
    ecbrRequest.post(`/company/pillars/${certificatePillarId}/associate-user`, {
      userId
    })
  // getUserCertificatePillars: async (certificateId, params = {}) => {
  //   const resp = await ecbrRequest.get(`/company/pillars`, {
  //     params: { ...params, certificateId }
  //   })
  //   const { pillarName } = params
  //   let data = resp.data
  //   if (pillarName) {
  //     data = {
  //       ...data,
  //       data: data.data?.filter((cert) =>
  //         cert.pillar.name.toLowerCase().startsWith(pillarName.toLowerCase())
  //       )
  //     }
  //   }
  //   return { ...resp, data }
  // }
}
